<!--
 * @Author: 'llhj' llhj0326@163.com
 * @Date: 2024-03-18 14:44:27
 * @LastEditors: 'llhj' llhj0326@163.com
 * @LastEditTime: 2025-04-17 15:20:13
 * @FilePath: \front\src\views\Hospital\components\backModal.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <el-dialog title="回退" width="530px" :visible.sync="backdata.active" :close-on-click-modal="false">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">
				<el-form-item label="回退到" prop="recordState">
					<el-select size="small" filterable clearable placeholder="请选择" v-model="form.recordState">
						<el-option v-for="item in optionLis[backdata.type]" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg">关 闭</el-button>
				<el-button type="primary" :loading="isLoading" @click="saveForm">保 存</el-button>
			</div>
		</el-dialog>
  </div>
</template>

<script>
import api from '@/service/api.js';

export default {
    props: {
        backdata:{
            required: true
        }
    },
    data() {
        return{
            dlg: {
				active: false,
				rules: {
					recordState: {required: true, message: '请选择状态'}
				}
			},
            form: {
				ihdid:null,
				recordState: null,
			},
            optionLis:{
               2:[//管理中
                    {
                        id:0,
                        name:'待管理'
                    },
                    {
                        id:3,
                        name:'已过期'
                    }
                ],
                3:[//已完成
                    {
                        id:0,
                        name:'待管理'
                    },
                    {
                        id:1,
                        name:'管理中'
                    },
                    {
                        id:3,
                        name:'已过期'
                    }
                ],
                4:[//已过期
                    {
                        id:0,
                        name:'待管理'
                    },
                ],
                5:[//勿访
                    {
                        id:0,
                        name:'待管理'
                    },
                    {
                        id:1,
                        name:'管理中'
                    },
                    {
                        id:3,
                        name:'已过期'
                    }
                ],               
            },
            isLoading:false
        }
    },
    methods:{
        closeDlg(data){
            this.$emit('closeDlg',data);
        },
        async saveForm() {
            this.form.ihdid=this.backdata.data.ihdId;

			// 回退
			let res;
			this.isLoading = true;
			res = await api.rollbackrecordState(this.form);
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.$message.success('保存成功');
			this.closeDlg('sucess');
		},
    }
}
</script>

<style>

</style>